import { Component, OnInit, Input, Output } from '@angular/core';
import { Store } from '@ngrx/store';
import { Router, ActivatedRoute } from '@angular/router';

import { CustomPropertiesInformationBar } from '../../../core/models/customPropertiesInformationBar';
import { InformationBarActions } from '../../../core/reducers/informationBar.actions';
import { Config } from '../../core/config';
import { TraceService } from './../../core/services/trace.service';
import { SyncronizationService } from './../../core/services/synchronization.service';
import { ViewerActions } from './../../core/reducers/viewer.actions';
import { combineLatest } from 'rxjs';
import { IAppState } from 'app/IAppState';

@Component({
  selector: 'biz-viewer-detail',
  templateUrl: './viewer-detail.component.html',
  styleUrls: ['./viewer-detail.component.scss']
})
export class ViewerDetailComponent implements OnInit {

  fileName: string;
  contentEntries: Array<IBATraceDetail>;
  showLoading = false;
  loadingMessage = '';
  hasMoreResults: boolean;
  continuationToken: string;
  traceFilter: ITraceFilter;
  gettingRows: boolean;
  downloadingFile: boolean;


  public subscription: any;

  private customPropertiesinformationBar: ICustomPropertiesInformationBar;

  constructor(
    private _store: Store<IAppState>,
    private _informationBarActions: InformationBarActions,
    private route: ActivatedRoute,
    private _router: Router,
    private _syncronization: SyncronizationService,
    private _traceService: TraceService,
    private _viewerActions: ViewerActions

  ) {

    this.initializeTraceDetailFilter();
  }

  ngOnInit() {
    this.customPropertiesinformationBar = new CustomPropertiesInformationBar();
    combineLatest(this.route.params, this._store.select((s) => s.stateViewer)).subscribe(([params, data]) => {
      const dataG: any = data;

      const fileName = params['file'];

      this.customPropertiesinformationBar.firstLevelInformation = 'Viewer';
      this.customPropertiesinformationBar.secondLevelInformation = fileName;
      this._store.dispatch(this._informationBarActions.Add(this.customPropertiesinformationBar));
      this.contentEntries = dataG.content;
      this.fileName = dataG.fileName;
      this.traceFilter.name = this.fileName;
      this.continuationToken = dataG.continuationToken;
      this.hasMoreResults = dataG.hasMoreResults;
    }).unsubscribe();

    this.subscription = this._syncronization.EventReloadContent.subscribe(this.loadMoreDetails.bind(this));
  }

  private loadMoreDetails() {
    this.gettingRows = true;
    this.traceFilter.filterProperties.continuationToken = this.continuationToken;
    this._traceService.getFileDetails(this.traceFilter)
      .subscribe((result: IFilterResult) => {

        this.continuationToken = result.ContinuationToken;
        this.hasMoreResults = result.HasMoreResults;

        if (this.contentEntries) {
          this.contentEntries.push.apply(this.contentEntries, result.Results);
        }
        else {
          this.contentEntries = result.Results;
        }
        this.showLoading = false;
        this.gettingRows = false;
      });
  }

  private createFileContent(entries: Array<IBATraceDetail>, fileName: string) {
    const fileContent: Array<Array<string>> = [];

    fileContent.push([fileName]);
    entries.forEach((value: IBATraceDetail) => {
      fileContent.push([value.MessageLog]);
    });

    return fileContent;
  }

  private initializeTraceDetailFilter() {
    this.traceFilter = {
      filterProperties: {
        pageSize: 100,
        continuationToken: this.continuationToken,
        sort: 'Asc'
      } as IFilterProperties,
      name: '',
      category: '',
      startDate: null,
      endDate: null,
    };
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
